import { translate } from 'i18n/i18n'
import type { TIrrigationDeviceStatus } from '../types'

export const getIrrigationStatusLabel = (status: TIrrigationDeviceStatus) => {
  switch (status) {
    case 'on':
      return translate.phrases.banyanApp('On')

    case 'off':
      return translate.phrases.banyanApp('Off')

    case 'error':
      return translate.phrases.banyanApp('Error')

    default:
      return translate.phrases.banyanApp('Unknown')
  }
}
